import { Component, ReactNode } from 'react'
import { datadogRum } from '@datadog/browser-rum'

const FallbackUI: React.FC<{ message: string }> = ({ message }) => (
  <div className="flex-center">
    <div>
      <div className="fs-40 primary-text text-center">Oops!</div>
      <div className="fs-18 mb-5 danger-text">
        {message || 'Something went wrong! Please try reloading the page.'}
      </div>
    </div>
  </div>
)

type ErrorFallbackProps = {
  shouldLogError: boolean
  children: ReactNode
  message?: string
}

type ErrorFallbackState = {
  hasError: boolean
  error?: Error
}

class ErrorFallback extends Component<ErrorFallbackProps, ErrorFallbackState> {
  constructor(props: ErrorFallbackProps) {
    super(props)
    this.state = {
      hasError: false,
    }
  }

  static getDerivedStateFromError(error: unknown): ErrorFallbackState {
    return { hasError: true, error: error as Error }
  }

  componentDidCatch(error: Error): void {
    if (this.props.shouldLogError) {
      datadogRum.addError(error)
    }
  }

  render(): ReactNode {
    const { hasError, error } = this.state
    const { message = '' } = this.props

    if (hasError && error) {
      return <FallbackUI message={message} />
    }

    return this.props.children
  }
}

export default ErrorFallback
